export default "__VITE_ASSET__DTJigQOP__"